module.exports = __webpack_public_path__ + "img/20260122.2cbebd01.jpg";